/* eslint-disable import/prefer-default-export */
export const MAKE_FILTER_ALL = 'ALL';
